<template>
  <div class="card-header">
    <div class="header-top">
      <div class="title-section">
        <div class="qualification-label">{{ qualificationLabel }}</div>
        <slot name="chip"></slot>
      </div>
      <div
        class="action-buttons"
        :class="{ 'visibility-hidden': isEdit, disabled: isDisabled }"
      >
        <div
          class="btn-action"
          :class="{ 'is-disabled': isDisabled }"
          @click="handleDelete"
        >
          <vs-icon icon="delete" size="small" />
        </div>
        <div
          class="btn-action"
          :class="{ 'is-disabled': isDisabled }"
          @click="handleEdit"
        >
          <vs-icon icon="edit" size="small" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreviewCardHeader",
  props: {
    qualificationLabel: {
      type: String,
      default: "",
    },
    chipLabel: {
      type: String,
      default: "",
    },
    chipColor: {
      type: String,
      default: "#039BE5",
    },
    onDelete: {
      type: Function,
      default: () => {},
    },
    onEdit: {
      type: Function,
      default: () => {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleDelete() {
      if (this.isDisabled) {
        return;
      }
      this.onDelete();
    },
    handleEdit() {
      if (this.isDisabled) {
        return;
      }
      this.onEdit();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.card-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid $aisea-light-white;
  padding: 12px 20px 12px 30px;

  .header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    .title-section {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 24px;

      .qualification-label {
        color: #626262;
        font-family: "Hiragino Sans", -apple-system, Roboto, Helvetica,
          sans-serif;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 30px;
        letter-spacing: 0.2px;
      }
    }

    .action-buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;

      .btn-action {
        display: flex;
        width: 38px;
        height: 38px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: background-color 0.3s ease;

        &:hover {
          background-color: rgba(0, 0, 0, 0.05);
          border-radius: 6px;
        }

        &.is-disabled {
          cursor: not-allowed;
          opacity: 0.5;
          pointer-events: none;
        }
      }
    }

    .visibility-hidden {
      visibility: hidden;
    }

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
</style>
